import { render } from "./BaseHeader.vue?vue&type=template&id=1842dc65"
import script from "./BaseHeader.vue?vue&type=script&lang=js"
export * from "./BaseHeader.vue?vue&type=script&lang=js"

import "./BaseHeader.vue?vue&type=style&index=0&id=1842dc65&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__